import { useEffect, useRef } from 'react';

export const useScript = (src: string, onLoadCallback?: () => void) => {
  const callbackRef = useRef(onLoadCallback);

  useEffect(() => {
    callbackRef.current = onLoadCallback;
  }, [onLoadCallback]);

  useEffect(() => {
    if (!src) return;

    if (window[src as keyof Window] || document.querySelector(`script[src="${src}"]`)) {
      callbackRef.current?.();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    script.onload = () => {
      console.log(`Script loaded: ${src}`);
      callbackRef.current?.();
    };

    script.onerror = (error) => {
      console.error(`Failed to load script: ${src}`, error);
    };

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [src]);
};